/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentDetailTranscriptionQueryResponse, GetFragmentDetailTranscriptionPathParams, GetFragmentDetailTranscription404 } from "../models/GetFragmentDetailTranscription";

export function getGetFragmentDetailTranscriptionUrl(id: GetFragmentDetailTranscriptionPathParams["id"]) {
  const res = { method: 'GET', url: `/fragments/${id}/transcription` as const }
  return res
}

/**
 * @summary Get fragment transcription
 * {@link /fragments/:id/transcription}
 */
export async function getFragmentDetailTranscription(id: GetFragmentDetailTranscriptionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<GetFragmentDetailTranscription404>, unknown>({ method : "GET", url : getGetFragmentDetailTranscriptionUrl(id).url.toString(), ... requestConfig })
  return res.data
}